import React from "react";

import "./paginator.scss";

interface PaginatorInter {
  arrLength: number;
  initialValue: number;
  currentValue: number;
  lastValue: number;
  setInitialValueH: any;
  setLastValue: any;
  setCurrentValue: any;
}

const Paginator = (props: PaginatorInter) => {
  const {
    arrLength,
    initialValue,
    currentValue,
    lastValue,
    setInitialValueH,
    setLastValue,
    setCurrentValue,
  } = props;

  const numsHandler = () => {
    let nums = Array();

    for (let i = 1; i <= Math.ceil(arrLength / 10); i++) {
      nums.push(i);
    }

    return nums;
  };

  const clickNumHandler = (event) => {
    const { innerHTML } = event.target;
    let initialValue =
      parseInt(innerHTML) === 1
        ? 0
        : parseInt(innerHTML) === Math.ceil(arrLength / 10)
        ? parseInt(innerHTML) - 1
        : parseInt(innerHTML) - 1;
    let lastValue =
      parseInt(innerHTML) === Math.ceil(arrLength / 10)
        ? parseInt(innerHTML)
        : parseInt(innerHTML) === 1
        ? 1
        : parseInt(innerHTML);

    setCurrentValue(parseInt(innerHTML));
    setInitialValueH(initialValue);
    setLastValue(lastValue);
  };

  const handleGoBack = () => {
    if (initialValue === 0) {
      setInitialValueH(0);
      return;
    }

    setInitialValueH(initialValue - 1);
    setCurrentValue(currentValue - 1);
    setLastValue(lastValue - 1);
  };

  const handleGoNext = () => {
    if (currentValue === Math.ceil(arrLength / 10)) {
      setLastValue(Math.ceil(arrLength / 10));
      return;
    } else {
      setInitialValueH(currentValue);
      setCurrentValue(currentValue + 1);
      setLastValue(currentValue + 1);
    }
  };

  return (
    <div className="a-paginator">
      <div className="a-paginator__btn">
        {arrLength > 10 && (
          <span
            className={`a-paginator__btn--back ${
              initialValue == 0 ? "" : "active"
            }`}
            onClick={handleGoBack}
          >
            Atrás
          </span>
        )}
      </div>

      <div className="a-paginator__nums">
        {numsHandler().map((elem, idx) => {
          return (
            <span
              className={`o-member-grid__desk-pags-child ${
                currentValue === idx + 1 ? "active" : ""
              }`}
              onClick={clickNumHandler}
              key={idx}
            >
              {elem}
            </span>
          );
        })}
      </div>

      <div className="a-paginator__btn">
        {arrLength > 10 && (
          <span
            className={`a-paginator__btn--back ${
              currentValue !== Math.ceil(arrLength / 10) ? "active" : ""
            }`}
            onClick={handleGoNext}
          >
            Siguiente
          </span>
        )}
      </div>
    </div>
  );
};

export default Paginator;
